export const COMPLETE_DATE_LENGTH = 10;

export const DATE_FORMAT = 'MM/dd/yyyy';

export const DEFAULT_DISPLAY_TEXT = 'Select date range';

export const DISPLAY_SEPARATOR = '–';
